import { Box, makeStyles, Typography } from "@material-ui/core";
import dayjs from "dayjs";
import * as React from "react";

import { UserUpdate } from "@/api/generated";
import { CustomButton } from "@/components/Button";
import { layoutTokens, textStyles } from "@/designTokens";
import { usePatchUser } from "@/hooks/usePatchUser";
import theme from "@/theme";
import { sendEventToAppMeasurementTool, AppEventTokenEnum } from "@/utilities/capacitorLogic";

import bullet from "../../../../../assets/image/settings_v2/bullet.svg";
import { SettingItemsProps } from "../../SettingsPage";
import { SettingsHelper, useSettingsContentStyles } from "../SettingsContent";

const useStyles = makeStyles({
  warning: {
    padding: layoutTokens.space[16],
    borderRadius: layoutTokens.radius.sm,
    backgroundColor: theme.palette.semantic["status/error-bg"],
    display: "flex",
    flexDirection: "column",
    gap: layoutTokens.space[12],
  },
  row: { display: "flex", alignItems: "flex-start", gap: layoutTokens.space[8] },
  text: { ...textStyles["SP/Body/Small"] },
  number: {
    width: 24,
    height: 24,
    flexShrink: 0,
    borderRadius: layoutTokens.radius.full,
    backgroundColor: theme.palette.semantic["state/selected-bg"],
    color: theme.palette.primary.main,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    ...textStyles["Number/Caption"],
  },
});
export const DeleteAccount: React.FC<SettingItemsProps> = () => {
  const classes = useSettingsContentStyles();
  const styles = useStyles();
  const { patchUser } = usePatchUser();
  const handleClick = () => {
    const request: UserUpdate = {
      withdrawal_intended_at: dayjs().format(),
    };
    patchUser(request);
    sendEventToAppMeasurementTool(AppEventTokenEnum.DeleteAccountRequest);
    window.open("https://form.run/@propally-1619689827", "_blank", "noopener,noreferrer");
  };
  return (
    <>
      <Box className={classes.stack}>
        <Box>
          <Typography component="h2" className={classes.heading}>
            退会について
          </Typography>
          <Box mt={1}>
            <Typography className={classes.description}>退会すると、これまでの記録はすべて消えます。</Typography>
          </Box>
        </Box>
        <Box className={styles.warning}>
          <Typography className={classes.noteHeading}>消えるもの</Typography>
          {["登録した物件と、毎月の収支", "保管した書類と、書き留めたメモ", "プランナーから届いたメッセージ"].map(
            (text) => (
              <Box key={text} className={styles.row}>
                <img src={bullet} alt="" width={6} height={18} />
                <Typography className={styles.text}>{text}</Typography>
              </Box>
            )
          )}
          <Typography className={styles.text}>元に戻すことはできません。</Typography>
        </Box>
        <Typography className={classes.noteHeading}>退会の流れ</Typography>
        <Box display="flex" flexDirection="column" style={{ gap: 16 }}>
          {["申請フォームから申し込む", "担当者が内容を確認する", "アカウントを削除し、メールでお知らせする"].map(
            (text, index) => (
              <Box key={text} className={styles.row} style={{ gap: 12 }}>
                <span className={styles.number}>{index + 1}</span>
                <Typography className={classes.description} style={{ color: theme.palette.text.primary }}>
                  {text}
                </Typography>
              </Box>
            )
          )}
        </Box>
      </Box>
      <Box className={classes.actions}>
        <SettingsHelper>ブラウザが開きます。</SettingsHelper>
        <CustomButton buttonSize="L" tone="outline" onClick={handleClick}>
          退会の申請フォームを開く
        </CustomButton>
      </Box>
    </>
  );
};
